import { useState } from 'react';

const FAQHoneymoon = () => {
    const faqs = [
        {
          question: "Where are the most popular honeymoon destinations?",
          answer: "Ah, the million-dollar question!  It truly depends on your vision as a couple.  For those classic beach honeymoons, the Maldives, Bora Bora, and Santorini are always top contenders. If you're more into exploring cities and soaking up culture, consider romantic spots like Paris, Venice, or Kyoto.  And for adventurous duos, Iceland, Tanzania (for a safari!), or even Patagonia could be incredible."
        },
        {
          question: "How far in advance should we book our honeymoon?",
          answer: "The sooner, the better! Especially if you're set on a specific destination or traveling during peak season.  Popular resorts and flights can book up quickly, sometimes even a year in advance.  Plus, booking early often gives you access to better deals and early bird discounts."
        },
        {
          question: "What's the best way to choose a honeymoon destination that suits both of us?",
          answer: "Talk to each other!  Discuss your dream honeymoon visions, your interests, and your budget.  Do you picture yourselves relaxing on a beach, exploring a new city, or embarking on an adventure?  Once you have a general idea, you can start researching destinations and activities that appeal to both of you."
        },
        {
          question: "We're on a tight budget. Can we still have an amazing honeymoon?",
          answer: "Absolutely!  Honeymoons don't have to break the bank.  Consider exploring less-traveled destinations, traveling during the shoulder seasons for lower prices, or opting for shorter trips.  You can also find great deals on all-inclusive packages or look for romantic guesthouses and charming bed and breakfasts instead of luxury resorts."
        },
        {
          question: "What are some tips for planning a stress-free honeymoon?",
          answer: "Start planning early to avoid last-minute stress.  Set a realistic budget and stick to it.  Consider using a travel agent to help with the planning process and take advantage of their expertise.  Most importantly, remember that your honeymoon is about celebrating your love and creating lasting memories together, so focus on enjoying each other's company and embracing the journey!"
        }
      ];

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="mt-8 px-4 md:px-0">
      <h2 className="text-2xl font-semibold mb-4">FAQs</h2>
      {faqs.map((faq, index) => (
        <div key={index} className="mb-4 lg:w-[900px]">
          <div
            className={`cursor-pointer py-4 px-4 bg-white rounded-lg shadow-sm border border-light hover:shadow-md transition-shadow ${activeIndex === index ? 'pb-8' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="flex justify-between items-center">
              <h3 className="text-base md:text-lg font-medium w-[90%]">{faq.question}</h3>
              <svg
                className={`w-8 h-8 transition-transform duration-300 p-1 rounded-full text-halo-pink hover:bg-halo-pink hover:text-white focus:outline-none ${activeIndex === index ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            {activeIndex === index && (
              <p className="mt-3 text-gray-700">{faq.answer}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQHoneymoon;
